import { isElectron } from '../utils/env'

/**
 * Returns the Electron preload bridge or null when running outside Electron
 * (e.g. in a regular browser during development, or when the preload failed).
 */
export function getDesktopBridge() {
  return window.arkitectDesktop ?? null
}

export const windowApi = {
  minimize: async () => {
    const bridge = getDesktopBridge()
    if (bridge?.window) return bridge.window.minimize()
  },
  toggleMaximize: async () => {
    const bridge = getDesktopBridge()
    if (bridge?.window) return bridge.window.toggleMaximize()
  },
  close: async () => {
    const bridge = getDesktopBridge()
    if (bridge?.window) return bridge.window.close()
  },
}
